import React from "react";
import { css, setColor_0083f5, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

type Props = {
  isArabic: boolean;
};

const isArabicLang = setProps<Props>(({ isArabic }) => isArabic)(css`
  text-align: right;
`);

const isNotArabicLang = setProps<Props>(({ isArabic }) => !isArabic)(css`
  text-align: left;
`);

export const SResetPasswordButton = styled.button<Props & React.ButtonHTMLAttributes<HTMLButtonElement>>`
  margin-top: 32px;
  text-align: left;

  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_0083f5};
  ${isNotArabicLang};
  ${isArabicLang};
`;
